import { Box, Flex, Tooltip } from '@chakra-ui/react';

import { Txt } from '@app/components/common';
import { MasterOutlet } from '@app/api/models';

export const OutletColumn = (value: MasterOutlet | null) => {
    if (!value) {
      return <Txt textColor='var(--chakra-colors-gray-400)'>(пусто)</Txt>;
    }
    return <Box>
      <Flex gap={2}>
        <Txt textColor='gray.500'>[{value?.id}]</Txt>
        <Txt textColor='brand-500'>{value?.legal_name || value?.name}</Txt>
      </Flex>
      <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
        <Tooltip label={value?.full_address || value?.address?.full_address || ''}>
          <Box display='flex'>
            <Txt>{value?.full_address || value?.address?.full_address.slice(0, 18)}...</Txt>
          </Box>
        </Tooltip>
      </Box>
    </Box>;
};